import PropTypes from 'prop-types';
import React from 'react';
import DataDownload from '../core/DataDownload';
import TabbedSubmenu from '../core/TabbedSubmenu.js';
import workerCode from '../vocabulary/workers/tsv-export';
import DatasetExportExamples from './DatasetExportExamples.js';

class DatasetExport extends React.Component {

    render() {

        const { id, graph, ontologyProjectAssociation, defaultLang, annotations, entitlements } = this.props;

        return (
            <TabbedSubmenu tabs={["Download Data", "Generate CSV/HTML/TSV/XLSX"]}>
                <DataDownload
                    title="Dataset"
                    graph={graph}
                    resource={id}
                    annotationOption={annotations}
                    exportName="datasetexport"
                    message="Includes data for the dataset and all resources that are part of it." />
                <DatasetExportExamples
                    ontologyProjectAssociation={ontologyProjectAssociation}
                    tsvFunction={workerCode}
                    tsvMode="dataset"
                    id={id}
                    entitlements={entitlements}
                    graph={graph}
                    options={{
                        labelProp: 'label',
                        columns: {
                            "https://grafsync.graphifi.com/schema/tsv/resources": "Resources",
                            "https://grafsync.graphifi.com/schema/tsv/IRI": "IRI"
                        },
                        datatypeProperties: {},
                        objectProperties: {
                            "type": {
                                "displayName": "Class",
                                "iri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                            }
                        }
                    }}
                    defaultLang={defaultLang}
                    resource={this.props.id}
                    exportName="datasetlist" />
            </TabbedSubmenu>
        );
    }
}

DatasetExport.propTypes = {
    entitlements: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    annotations: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default DatasetExport;